import { render, staticRenderFns } from "./CompanyStyle.vue?vue&type=template&id=25bc4a7a&"
import script from "./CompanyStyle.vue?vue&type=script&lang=js&"
export * from "./CompanyStyle.vue?vue&type=script&lang=js&"
import style0 from "./CompanyStyle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports